import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

const Transportation = () => {
  return (
    <React.Fragment>
      <SEO title="Transportation | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Transportation"
        content="For Participants"
        contentTwo="Transportation"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content accommodation-page">
          <h2>Transportation Facilities in Beijing</h2>

          <section className="accommodation-section">
            <p>
              ICSI&apos;2026 will be held in Beijing, China. For updated conference venue and
              on-site access information, please visit the{" "}
              <Link to={process.env.PUBLIC_URL + "/venue"}>Venue</Link> page.
            </p>
            <p>
              <em>
                Tip: Beijing Subway accepts mobile payment (Alipay / WeChat Pay) at ticket gates.
                Allow extra time during rush hours (07:30–09:30 and 17:00–19:30).
              </em>
            </p>
          </section>

          <section className="accommodation-section">
            <h3>Beijing Daxing International Airport</h3>
            <br />
            <p>
              <img src="./images/beijing/airport1.png" width={650} alt="Beijing Daxing International Airport" />
            </p>
            <p>
              Beijing Daxing International Airport (PKX), also known as Beijing New Airport, is the
              airport featuring the second largest single-building terminal in the world. It opened
              its doors on September 26, 2019, and is a multi-awarded airport. It is also the second
              international airport in Beijing. Indeed, Beijing Daxing Airport and Beijing Capital
              International Airport are the two international aviation hubs of the Chinese capital,
              as the adjacent Beijing Nanyuan Airport closed once the new airport began its
              operation.
              <br></br>
              <br></br>
            </p>
            <p>
              <img src="./images/beijing/airport2.png" width={650} alt="Beijing Daxing International Airport terminal" />
            </p>
            <br></br>
            <p>
              The airport&apos;s design is pioneering. Designed by the renowned architect Zaha
              Hadid, the terminal is spread over 700,000m² (7,500,000 sq ft) and is considered a
              state of art. Moreover, PKX Airport boasts 4 runways (as well as one military runway)
              and an impressive number of 82 boarding gates. On the other hand, its location in
              Daxing District (the southern suburbs of Beijing) is ideal for serving the Chinese
              capital and the neighboring areas of Hebei and Tianjin. The new mega-airport hub
              served more than 39.4 million passengers in 2023 and is expected to reach an
              outstanding 100 million passenger flow in the future.
            </p>
            <p>
              For more information, please visit{" "}
              <a href="https://daxing-pkx-airport.com/">https://daxing-pkx-airport.com/</a>
            </p>

            <h3>Beijing Capital International Airport</h3>
            <br />
            <p>
              <img src="./images/beijing/airport3.jpg" width={650} alt="Beijing Capital International Airport" />
            </p>
            <p>
              Beijing Capital International Airport (IATA: PEK, ICAO: ZBAA) is the main
              international airport serving the city of Beijing in People&apos;s Republic of China.
              It is one of the world&apos;s busiest airports and the largest Chinese airport.
              <br></br>
            </p>
            <p>
              <img src="./images/beijing/airport4.png" width={650} alt="Beijing Capital International Airport terminal" />
            </p>
            <br></br>
            <p>
              Beijing Capital Airport is located 32 km (20 miles) northeast of city center, at
              Chaoyang-Sunyi District.
            </p>
            <p>
              For more information, please visit{" "}
              <a href="https://en.bcia.com.cn/">https://en.bcia.com.cn/</a>
            </p>
          </section>

          <section className="accommodation-section">
            <hr></hr>
            <h3>Beijing Railway Station</h3>
            <br />
            <img src="./images/beijing/rw1.jpg" width={650} alt="Beijing Railway Station" />
            <p>
              Beijing Railway Station is one of the oldest and most important railway stations in
              Beijing. Located in the Dongcheng District, it serves as a major hub for trains heading
              to northeastern and eastern China. The station features a distinctive Soviet-style
              architecture, reflecting its historical significance and cultural heritage.
            </p>
            <p>
              <img src="./images/beijing/rww1.png" width={650} alt="Beijing Railway Station map" />
            </p>
            <br></br>
            <p>
              Today, Beijing Railway Station handles a mix of conventional and high-speed trains,
              connecting Beijing to cities like Shanghai, Harbin, and Tianjin. It is conveniently
              accessible via Beijing Subway Line 2, making it a key transportation hub for both
              locals and tourists.
            </p>

            <hr></hr>
            <h3>Beijing North Railway Station</h3>
            <br />
            <img src="./images/beijing/rw2.jpg" width={650} alt="Beijing North Railway Station" />
            <p>
              Beijing North Railway Station is a smaller but strategically located station in the
              Xicheng District. It primarily serves trains to northern destinations, including the
              popular high-speed train to Badaling Great Wall and the suburban S2 line. The station
              underwent a major renovation in recent years to modernize its facilities.
            </p>
            <p>
              <img src="./images/beijing/rww2.png" width={650} alt="Beijing North Railway Station map" />
            </p>
            <br></br>
            <p>
              Known for its proximity to the Beijing Zoo and the National Library, Beijing North
              Railway Station is a convenient starting point for travelers exploring the city&apos;s
              cultural attractions. It is also connected to Beijing Subway Lines 2, 4, and 13,
              providing easy access to other parts of the city.
            </p>

            <hr></hr>
            <h3>Beijing South Railway Station</h3>
            <br />
            <img src="./images/beijing/rw3.jpg" width={650} alt="Beijing South Railway Station" />
            <p>
              Beijing South Railway Station is one of the largest and most modern railway stations
              in China. Located in the Fengtai District, it serves as the primary hub for high-speed
              trains, including the Beijing-Shanghai High-Speed Railway and the Beijing-Tianjin
              Intercity Railway.
            </p>
            <p>
              <img src="./images/beijing/rww3.png" width={650} alt="Beijing South Railway Station map" />
            </p>
            <br></br>
            <p>
              The station&apos;s futuristic design and state-of-the-art facilities make it a
              standout landmark in Beijing. It is well-integrated with the city&apos;s public
              transportation network, including Beijing Subway Lines 4 and 14, offering seamless
              connectivity for travelers. Beijing South Railway Station is a gateway to major
              cities across China, making it a vital part of the country&apos;s high-speed rail
              network.
            </p>
            <p align="justify">
              For high-speed train schedules and ticket booking, visit the official China Railway
              ticketing site:{" "}
              <a href="https://www.12306.cn/" target="_blank" rel="noopener noreferrer">
                https://www.12306.cn/
              </a>
            </p>
          </section>
        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Transportation;
